import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import logo from '../../assets/logo.svg'; // Import the logo
import { useAuth } from '../../hooks/useAuth';
// import Button from '../ui/Button'; // If you made a custom one

export default function Header() {
  const location = useLocation(); // Replaces usePathname
  const navigate = useNavigate();
  const { isAuthenticated, logout } = useAuth();

  // console.log(location.pathname); // For debugging current path

  const handleGetStarted = () => {
    // Navigate to login or a signup page, or dashboard if authenticated
    if (isAuthenticated) {
      navigate('/dashboard'); // or a dashboard route
    } else {
      navigate('/login');
    }
  };
  
  const handleLogout = () => {
    logout();
    navigate('/login');
  }

  return (
    <div className='relative z-10 p-3 px-5 border-b shadow-sm bg-white'>
      <div className='flex items-center justify-between'>
        <Link to="/">
          <img src={logo} width={150} height={40} alt='logo' /> 
        </Link>
        <div className='flex items-center gap-5'>
          {/* Example using DaisyUI button classes */}
          <button 
            className="btn btn-primary" // DaisyUI button
            onClick={handleGetStarted}
          >
            {isAuthenticated ? 'Dashboard' : 'Get Started'}
          </button>
          {isAuthenticated && (
            <button
              className="btn btn-ghost" // DaisyUI button
              onClick={handleLogout}
            >
              Logout
            </button>
          )}
        </div>
      </div>
    </div>
  );
}